import { Container } from '@ui/wrapper'
import AnmeldungForm from '@components/forms/anmeldung-form'

import { SectionWrapper, StyledText } from './style'

const AnmeldungArea = ({
  data,
  dataErrorMessages,
  registrationsFull,
  ...rest
}) => {
  const htmlContent = registrationsFull
    ? data.texts[3]?.content
    : data.texts[0]?.content

  return (
    <SectionWrapper {...rest}>
      <Container>
        {htmlContent && (
          <StyledText
            dangerouslySetInnerHTML={{
              __html: htmlContent
            }}
          />
        )}
        {data?.items?.length > 0 && !registrationsFull && (
          <AnmeldungForm data={data} dataErrorMessages={dataErrorMessages} />
        )}
      </Container>
    </SectionWrapper>
  )
}

export default AnmeldungArea
